import { useStepper } from "../../../../components/ui/stepper";
import {
  RadioGroup,
  RadioGroupItem,
} from "../../../../components/ui/radio-group";
import { Label } from "../../../../components/ui/label";
import { Button } from "../../../../components/ui/button";
import { AnimatedTooltip } from "../../../../components/AnimatedTooltip";

export function RiskStepContent({
  section,
  sectionIndex,
  setSections,
  sections,
  fetchAnalysis,
}) {
  const { nextStep, prevStep, activeStep } = useStepper();

  const handleAnswer = (sectionIndex, questionIndex, value) => {
    setSections((prev) => {
      const updated = [...prev];
      updated[sectionIndex].questions[questionIndex].answer = value;
      return updated;
    });
  };

  // ✅ Check if all questions in this section are answered
  const allAnswered = section?.questions?.every((q) => q?.answer);
  return (
    <div className="h-auto flex flex-1 flex-col gap-4">
      <h2 className="text-lg font-semibold">{section.sub_title}</h2>

      <div className="flex flex-col gap-4 h-[490px] overflow-auto bg-muted rounded-md p-2">
        {section?.questions?.map((q, i) => {
          const topic = q?.label;
          const question = q?.question;
          const questionKey = `${section?.title}_${i}`;
          return (
            <div
              key={i}
              className="border p-3 rounded-md flex flex-col gap-3 bg-background"
              style={{
                borderColor:
                  q?.answer === "Yes"
                    ? section?.yes_color
                    : q?.answer === "No"
                    ? section?.no_color
                    : undefined,
              }}
            >
              <p>
                <span className="font-medium">{topic}: </span>
                {question}
              </p>
              <RadioGroup
                value={q.answer || ""}
                onValueChange={(value) => handleAnswer(sectionIndex, i, value)}
                className="flex gap-6"
              >
                {["Yes", "No"]?.map((option) => (
                  <div key={option} className="flex items-center space-x-2">
                    <RadioGroupItem
                      value={option}
                      id={`${questionKey}_${option}`}
                    />
                    <Label
                      htmlFor={`${questionKey}_${option}`}
                      className="cursor-pointer"
                    >
                      {option}
                    </Label>
                  </div>
                ))}
              </RadioGroup>
            </div>
          );
        })}
      </div>

      {/* Navigation Buttons */}
      <div className="flex justify-end gap-3">
        {activeStep > 0 && (
          <Button variant="secondary" onClick={prevStep}>
            Previous
          </Button>
        )}

        {activeStep < sectionIndex + 1 ? (
          !allAnswered ? (
            <AnimatedTooltip
              title={" Please answer all questions before proceeding"}
            >
              <Button onClick={nextStep} disabled={!allAnswered}>
                Next
              </Button>
            </AnimatedTooltip>
          ) : (
            <Button
              onClick={() => {
                nextStep();
                if (activeStep === sections.length - 1) {
                  fetchAnalysis(sections);
                }
              }}
              disabled={!allAnswered}
            >
              Next
            </Button>
          )
        ) : (
          <Button type="submit">Submit</Button>
        )}
      </div>
    </div>
  );
}
